var remjs = (function (doc, win) {
    var docEl = doc.documentElement;
    var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
    function recalc() {
        var clientWidth = docEl.clientWidth;
        if (!clientWidth) {
            return false;
        }
        docEl.style.fontSize = 20 * (clientWidth / 320) + "px";
        return true;
    }
    if (!doc.addEventListener) {
        return false;
    }
    win.addEventListener(resizeEvt, recalc, false);
    doc.addEventListener('DOMContentLoaded', recalc, false);
    return true;
})(document, window);
export { remjs };
//# sourceMappingURL=rem.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/utils/rem.js
// module id = 1226
// module chunks = 0